<div class="page-layout">

    <div class="page-header">
        <div class="header-title-group">
            <h1 class="cyber-title">>_ {{ selectedProject.id ? 'METADATA_PROYECTO' : 'NUEVO_PROYECTO' }}</h1>
            <p class="subtitle">Gestión de alcance y ciclo de vida del proyecto.</p>
        </div>
        <div class="header-actions">
            <button class="btn secondary" (click)="cancel()">
                <svg viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
                Volver
            </button>
            <button class="btn danger" (click)="deleteEntity()" *ngIf="selectedProject.id">
                <svg viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                Borrar
            </button>
            <button class="btn primary btn-glow" (click)="saveEntity()">
                <svg viewBox="0 0 24 24"><path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"/></svg>
                Guardar Datos
            </button>
        </div>
    </div>

    <div class="project-container">
        <div class="project-data">
            <h3 class="section-title">Datos Generales</h3>

            <div class="form-group">
                <label class="cyber-label">Nombre del Proyecto:</label>
                <input class="form-control" [(ngModel)]="selectedProject.name" />
            </div>

            <div class="form-group">
                <label class="cyber-label">Descripción / Alcance:</label>
                <textarea class="form-control" [(ngModel)]="selectedProject.description" maxlength="500" rows="4"></textarea>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="cyber-label">Fecha Inicio:</label>
                    <input class="form-control" type="date" [(ngModel)]="selectedProject.startdate" />
                </div>
                <div class="form-group">
                    <label class="cyber-label">Fecha Fin:</label>
                    <input class="form-control" type="date" [(ngModel)]="selectedProject.enddate" />
                </div>
                <div class="form-group">
                    <label class="cyber-label">Sociedad:</label>
                    <select class="form-control" [(ngModel)]="selectedSociety" (change)="onSocietyChange()" [compareWith]="compareSocieties">
                        <option *ngFor="let society of societies" [ngValue]="society">{{ society.name }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="cyber-label">Departamento:</label>
                    <select class="form-control" [(ngModel)]="selectedProject.department" (change)="onDepartmentChange()" [compareWith]="compareDepartments">
                        <option *ngFor="let department of departments" [ngValue]="department">{{ department.name }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="cyber-label">Tipo:</label>
                    <select class="form-control" [(ngModel)]="selectedProject.type" (change)="onProjectChange()" [compareWith]="compareTypes">
                        <option *ngFor="let type of types" [ngValue]="type">{{ type.name }}</option>
                    </select>
                </div>

                <!-- NUEVO 1a: multi-select de sistemas filtrado por cliente -->
                <div class="form-group">
                    <label class="cyber-label">Sistemas:</label>
                    <app-multi-select
                        [items]="filteredSystems"
                        [selected]="selectedProject.systems || []"
                        [displayField]="'name'"
                        [trackBy]="'id'"
                        [placeholder]="selectedSociety.client.id ? 'Seleccionar sistemas...' : 'Selecciona primero una sociedad'"
                        [disabled]="!selectedSociety.client.id"
                        (selectionChange)="onSystemsChange($event)">
                    </app-multi-select>
                </div>
            </div>
        </div>

        <div class="project-tasks">
            <div class="ide-tabs">
                <div class="tab" [class.active]="selectedTab === 'estimacion'" (click)="selectTab('estimacion')">
                    <svg viewBox="0 0 24 24"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>
                    estimation_tasks.json
                </div>
                <div class="tab" [class.active]="selectedTab === 'ejecucion'" (click)="selectTab('ejecucion')">
                    <svg viewBox="0 0 24 24"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9h-2V7h-2v5H6v-2h2V7c0-1.1.9-2 2-2h2v5h2v2h-2v-2z"/></svg>
                    execution_pipeline.yml
                </div>

                <button class="btn-ide-action" *ngIf="selectedTab === 'estimacion' && selectedProject.estimation" (click)="abrirEstimacion()">
                    >_ ABRIR ESTIMACIÓN DETALLADA
                </button>

                <ng-container *ngIf="selectedTab === 'ejecucion'">
                    <button class="btn-ide-action" (click)="abrirGestorEjecuciones()" *appHasPermission="'task:execution:manage'">
                        >_ ABRIR GESTOR DE EJECUCIONES
                    </button>
                </ng-container>
            </div>

            <div class="tab-content">
                <div *ngIf="selectedTab === 'estimacion'" class="tab-pane active">
                    <div class="table-scroll-area" *ngIf="selectedProject.estimation">
                        <table class="cyber-table">
                            <thead>
                                <tr>
                                    <th style="width: 55%">Requisito / Tarea</th>
                                    <th style="width: 25%">Perfil</th>
                                    <th style="text-align: center;">Horas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let requisito of selectedProject.estimation.requirements">
                                    <tr class="req-row">
                                        <td colspan="3" class="req-title">{{ requisito.description }}</td>
                                    </tr>
                                    <tr *ngFor="let tarea of requisito.tasks" class="task-row">
                                        <td style="padding-left: 25px;">
                                            <div class="task-title-container">
                                                <div class="task-title">
                                                    <span class="tree-line">|--</span> {{ tarea.name || tarea.description }}
                                                </div>
                                                <div class="task-subtitle indent-sm" *ngIf="tarea.name && tarea.description && tarea.name !== tarea.description">
                                                    {{ tarea.description }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{ tarea.profile || 'N/A' }}</td>
                                        <td style="text-align: center;">{{ tarea.estimatetime || 0 }}H</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                            <tfoot>
                                <tr class="total-row">
                                    <td colspan="2" style="text-align: right; font-weight: bold; font-size: 11px; text-transform: uppercase;">Sumatorio Total Estimado:</td>
                                    <td style="text-align: center; color: #a6e22e; font-weight: bold; font-size: 14px;">{{ totalHorasEstimadas }}H</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div *ngIf="!selectedProject.estimation" class="empty-state">
                        >_ No se ha generado ninguna estimación de tareas para este proyecto.
                    </div>
                </div>

                <div *ngIf="selectedTab === 'ejecucion'" class="tab-pane active">
                    <div class="table-scroll-area" *ngIf="selectedProject.taskexecutions && selectedProject.taskexecutions.length > 0">
                        <table class="cyber-table">
                            <thead>
                                <tr>
                                    <th style="width: 45%">Contexto / Tarea Ejecutada</th>
                                    <th>Subsistema</th>
                                    <th>Perfil</th>
                                    <th style="text-align: center;">Horas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let group of groupedExecutions">
                                    <tr class="req-row">
                                        <td colspan="4" class="req-title">{{ group.description }}</td>
                                    </tr>
                                    <ng-container *ngFor="let item of group.tasks">
                                        <tr class="task-row estimated-context">
                                            <td style="padding-left: 25px;">
                                                <div class="task-title-container">
                                                    <div class="task-title">
                                                        <span class="tree-line">|--</span> [Planificado] {{ item.task.name || item.task.description }}
                                                    </div>
                                                    <div class="task-subtitle indent-sm" *ngIf="item.task.name && item.task.description && item.task.name !== item.task.description">
                                                        {{ item.task.description }}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{{ item.task.subsystem || 'N/A' }}</td>
                                            <td>{{ item.task.profile || 'N/A' }}</td>
                                            <td style="text-align: center; color: #a0aec0;">Est: {{ item.task.estimatetime || 0 }}H</td>
                                        </tr>
                                        <tr *ngFor="let exec of item.executions" class="task-row execution-real">
                                            <td style="padding-left: 55px;">
                                                <div class="task-title-container">
                                                    <div class="task-title">
                                                        <span class="tree-line-exec">|----</span> {{ exec.name || exec.description }}
                                                    </div>
                                                    <div class="task-subtitle indent-md" *ngIf="exec.name && exec.description && exec.name !== exec.description">
                                                        {{ exec.description }}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{{ exec.subsystem || 'N/A' }}</td>
                                            <td>{{ exec.profile || 'N/A' }}</td>
                                            <td style="text-align: center; color: #ff5f56; font-weight: bold;">{{ exec.executedtime }}</td>
                                        </tr>
                                        <tr *ngIf="item.executions.length === 0" class="task-row empty-exec">
                                            <td colspan="4" style="padding-left: 55px; color: #6272a4; font-style: italic; font-size: 11px;">Sin imputaciones registradas.</td>
                                        </tr>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="transversalExecutions.length > 0">
                                    <tr class="req-row transversal-row" style="background-color: rgba(139, 233, 253, 0.05);">
                                        <td colspan="4" class="req-title" style="color: #8be9fd;">🔄 Tareas Transversales (Sin enlace directo)</td>
                                    </tr>
                                    <tr *ngFor="let exec of transversalExecutions" class="task-row execution-real">
                                        <td style="padding-left: 25px;">
                                            <div class="task-title-container">
                                                <div class="task-title">
                                                    <span class="tree-line-exec" style="color: #8be9fd;">|--</span> {{ exec.name || exec.description }}
                                                </div>
                                                <div class="task-subtitle indent-sm" *ngIf="exec.name && exec.description && exec.name !== exec.description">
                                                    {{ exec.description }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{ exec.subsystem || 'N/A' }}</td>
                                        <td>{{ exec.profile || 'N/A' }}</td>
                                        <td style="text-align: center; color: #8be9fd; font-weight: bold;">{{ exec.executedtime }}</td>
                                    </tr>
                                </ng-container>

                                <ng-container *ngIf="unplannedExecutions.length > 0">
                                    <tr class="req-row unplanned-row">
                                        <td colspan="4" class="req-title" style="color: #ffbd2e;">⚠️ Tareas No Planificadas (Sin enlace a estimación)</td>
                                    </tr>
                                    <tr *ngFor="let exec of unplannedExecutions" class="task-row execution-real">
                                        <td style="padding-left: 25px;">
                                            <div class="task-title-container">
                                                <div class="task-title">
                                                    <span class="tree-line-exec">|--</span> {{ exec.name || exec.description }}
                                                </div>
                                                <div class="task-subtitle indent-sm" *ngIf="exec.name && exec.description && exec.name !== exec.description">
                                                    {{ exec.description }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{ exec.subsystem || 'N/A' }}</td>
                                        <td>{{ exec.profile || 'N/A' }}</td>
                                        <td style="text-align: center; color: #ff5f56; font-weight: bold;">{{ exec.executedtime }}</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                            <tfoot>
                                <tr class="total-row">
                                    <td colspan="3" style="text-align: right; font-weight: bold; font-size: 11px; text-transform: uppercase;">Sumatorio Total Ejecutado:</td>
                                    <td style="text-align: center; color: #ff5f56; font-weight: bold; font-size: 14px;">{{ totalHorasEjecutadas }}H</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div *ngIf="!selectedProject.taskexecutions || selectedProject.taskexecutions.length === 0" class="empty-state">
                        >_ Pipeline de ejecución vacío. Listo para ingestar datos de JIRA/GitLab.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>